<template>
  <div ref="projecttype"
       class="pbr-index-chart">
<Empty></Empty>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../../../analysis/constant'
import Mixin from '../mixin'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartProjectNation',
  mixins: [Mixin],
  inject: ['chartDatas'],
  props:{
    height:{type: Number}
  },
  data () {
    return {
      projectTypeChart: null,
      optionProjecttype: null,
      isResize: false,
    }
  },
  computed: {
    chartData () {
      const projectChartData = this.chartDatas.projectChartData()
      // return projectChartData === {} ? [{name: '', num: 0}] : projectChartData.projectNationChart
      if (projectChartData.hasOwnProperty('projectNationChart') && projectChartData.projectNationChart.length > 0) {
        return projectChartData.projectNationChart
      }
      return [{name: '', num: 0}]
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.projecttype){
        return
      }
      if (this.projectTypeChart) {
        this.projectTypeChart.dispose()
      }
      if (!this.chartData) {
        return
      }
      let countContrastDom = this.$refs.projecttype
      this.projectTypeChart = echarts.init(countContrastDom, theme, {devicePixelRatio: 2.5,height: this.height})
      this.projectTypeChart.setOption(this.optionProjecttype)
      // this.projectTypeChart.resize({height})
      this.projectTypeChart.on('click', (param) => {
        self.dispatch('pbrIndex', 'filterData', {module: 'xm', condition: {type: 'country', title: param.data.name, id: param.data.id}})
      })

      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.projectTypeChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      let that = this
      this.optionProjecttype = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: that.$t('charts.home.project.countries'),
          left: 'center',
          top:0
        },
        tooltip:{
          confine:true,
          className: 'pbr-echarts-formatter-box',
          backgroundColor: "rgba(255,255,255,0.7)",
          textStyle:{
            color:"inherit"
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        dataset: {
          dimensions: ['name', 'num', 'percent', 'id'],
          source: this.chartData
        },
        grid: {
          bottom: 0,
          top: this.showTitle ? 30 : 0,
          left: 0,
          containLabel: true
        },
        // visualMap: {
        //   show: false,
        //   orient: 'horizontal',
        //   left: 'center',
        //   min: 0,
        //   max: 10,
        //   text: ['High Score', 'Low Score'],
        //   // Map the score column to color
        //   dimension: 0,
        //   inRange: {
        //     color: ['#65B581', '#FFCE34', '#FD665F']
        //   }
        // },
        xAxis: {},
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          inverse: true
        },
        series:
          {
            name:that.$t('charts.home.project.countries'),
            type: 'bar',
            colorBy:'data',
            label: {
              show: true
            },
            emphasis: {
              itemStyle: {
                fontSize: 18,
                opacity: 1
              }
            }
          }

      }
    },
    resize () {
      this.isResize = true
      this.projectTypeChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },

  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.projectTypeChart) {
            this.projectTypeChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
